module.exports = __webpack_public_path__ + "static/img/pc-kv2.2ac532fa.png";